export default {
  email: 'Email',
  password: 'Senha',
  enter: 'Entrar',
  notFound: 'Usuário não encontrado',
  Unauthorized: 'Senha inválida',
  genericErrorMsg: 'Ops, não conseguimos fazer o login, tente novamente mais tarde.'
};

